import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import { TOnlineBankWithProvider } from './BankSelectionModal.types';
import { ChooseBank } from './ChooseBank';
import { ConnectBank } from './ConnectBank';

export const BankSelectionBody = ({
    linkingForBankVerification = false
}: {
    linkingForBankVerification?: boolean;
}) => {
    const [selectedBank, setSelectedBank] =
        useState<TOnlineBankWithProvider | null>(null);

    const selectBank = (bank: TOnlineBankWithProvider) => {
        tracking.ampli.trueLayerBankSelection({
            bankId: bank.bank_id,
            bankName: bank.bank_name
        });

        setSelectedBank(bank);
    };

    return (
        <>
            {selectedBank ? (
                <ConnectBank
                    selectedBank={selectedBank}
                    unselectBank={() => setSelectedBank(null)}
                    linkingForBankVerification={linkingForBankVerification}
                />
            ) : (
                <ChooseBank
                    selectBank={selectBank}
                    linkingForBankVerification={linkingForBankVerification}
                />
            )}
        </>
    );
};
